import { KbGroup, KbGroupSummary } from 'types/KbGroupTypes';
import useHttp from '../helpers/HttpMethods';

class KbGroupsService {
  static async list(): Promise<KbGroupSummary[]> {
    return await useHttp().get('/kb-groups');
  }

  static async listWithFolders(): Promise<KbGroup[]> {
    return await useHttp().get('/kb-groups/with-folders');
  }

  static async create(body: {
    name: string;
    description: string;
  }): Promise<KbGroup> {
    return await useHttp().post(body, '/kb-groups');
  }

  static async update(
    kbGroupId: number,
    body: {
      name: string;
      description: string;
    }
  ): Promise<KbGroup> {
    return await useHttp().put(body, `/kb-groups/${kbGroupId}`);
  }

  static async delete(kbGroupId: number): Promise<void> {
    return await useHttp().del(`/kb-groups/${kbGroupId}`);
  }
}

export default KbGroupsService;
